let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aq2De")).then(() => parcelRequire('70nnk'));